import React, { useState, useEffect, useRef } from 'react';

const CameraModal = ({ onClose, onPhotoCapture }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [cameraStream, setCameraStream] = useState(null);
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  
  useEffect(() => {
    startCamera();
    return () => {
      if (cameraStream) {
        cameraStream.getTracks().forEach(track => track.stop());
      }
    };
  }, []);
  
  const startCamera = async () => {
    try {
      console.log('🎥 Iniciando cámara...');
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { facingMode: { ideal: 'user' }, width: { ideal: 640 }, height: { ideal: 480 } },
        audio: false 
      });
      setCameraStream(stream);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (error) {
      console.error('Error cámara:', error);
      // Si la cámara falla, continuar el registro sin foto
      if (window.confirm('⚠️ No se pudo acceder a la cámara.\n\n¿Deseas registrar la asistencia sin foto?')) {
        if (onPhotoCapture) onPhotoCapture(null);
        onClose();
      } else {
        onClose();
      }
    }
  };
  
  const takePicture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    
    const width = video.videoWidth || 640;
    const height = video.videoHeight || 480;
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(video, 0, 0, width, height);
    setCapturedPhoto(canvas.toDataURL('image/jpeg', 0.95));
  };
  
  const confirmPhoto = () => {
    console.log('📸 Confirmando foto...');
    console.log('capturedPhoto:', capturedPhoto ? 'SÍ' : 'NO');
    console.log('onPhotoCapture:', typeof onPhotoCapture);
    
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
    }
    
    if (capturedPhoto && onPhotoCapture) {
      onPhotoCapture(capturedPhoto);
    }
    
    onClose();
  };
  
  const handleClose = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach(track => track.stop());
    }
    onClose();
  };

  return (
    <div className="modal-overlay" style={{zIndex: 10000}} onClick={(e) => e.stopPropagation()}>
      <div className="camera-modal" onClick={(e) => e.stopPropagation()}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px'}}>
          <h2 style={{margin:0}}>📸 Verificación Biométrica</h2>
          <button onClick={handleClose} style={{fontSize:'24px', border:'none', background:'transparent', cursor:'pointer'}}>✕</button>
        </div>
        {!capturedPhoto ? (
          <>
            <video ref={videoRef} autoPlay playsInline muted style={{width:"100%", background:"#000"}}></video>
            <canvas ref={canvasRef} style={{display:'none'}}></canvas>
            <button onClick={takePicture}>📸 Tomar Foto</button>
          </>
        ) : (
          <>
            <img src={capturedPhoto} alt="Selfie" style={{width:"100%"}} />
            <button onClick={() => setCapturedPhoto(null)}>🔄 Otra</button>
            <button onClick={confirmPhoto}>✅ Confirmar</button>
          </>
        )}
      </div>
    </div>
  );
};

export default CameraModal;
